<template>
  <div id="kebai-login">
    <div class="login-header">
      <div class="logo-view">
        <img src="~@/assets/images/logo.png" alt />
      </div>
      <div class="navactivebj">
        <img src="~@/assets/images/navactivebj.png" alt />
      </div>
    </div>
    <div class="page-main-body">
      <div class="page-main-container">
        <div class="page-left-container">
          <div class="center-image">
            <img class="box-rotate" src="~@/assets/images/loginleftbj.png" />
          </div>
        </div>
        <div class="page-login-card">
          <div class="page-login-box">
            <div class="head">
              <div class="image-desc">登录</div>
            </div>

            <div
              style="margin-top: 20px;"
              class="inputbox inpusername kebai-icons-user icon-middle"
            >
              <input
                v-model="model.username"
                autocomplete="off"
                placeholder="账号"
                class="username full"
                type="text"
              />
            </div>
            <div class="inputbox inppassword kebai-icons-lock icon-middle">
              <input
                v-model="model.password"
                autocomplete="off"
                placeholder="密码"
                class="password full"
                type="password"
              />
            </div>
            <div class="inputbox inpcode icon-middle">
              <input
                v-model="model.code"
                autocomplete="off"
                placeholder="输入验证码"
                class="code"
                style="width: 60%;padding-left: 20px;"
                type="text"
              />
              <img
                @click="newCodeImage"
                :src="codeImageUrl"
                style="cursor: pointer; width: 35%; margin-left: 20px"
              />
            </div>
            <div class="inputbox" style="margin-top: 40px;">
              <input
                @click="submitClick"
                class="button button-login submit full"
                value="登录"
                type="button"
              />
            </div>
            <div class="btn-group help-button">
              <span class="inputbox rememberme">
                <el-checkbox v-model="model.rmb">记住密码</el-checkbox>
              </span>
              <span
                @click="clickForgetPassword"
                style="cursor: pointer"
                class="inputbox forget"
              >忘记密码?</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="login-footer">
      <p class="p-height">Copyright©1999-2020 中国移动 版权所有 本网站支持IPv6访问</p>
      <p class="p-height">中华人民共和国增值电信业务经营许可证 经营许可证编号：A2.B1.B2-20100001</p>
      <p class="p-height marginTop">技术支持：中国移动通信集团有限公司</p>
    </div>
  </div>
</template>

<script>
import ApiRequest from "./api-login";
import background from "./background";
import { Base64 } from "js-base64";
export default {
  data() {
    return {
      apiReq: new ApiRequest(this),
      model: {
        captchaKey: new Date().getTime(),
        username: null,
        password: null,
        code: null,
        rmb: false,
        Authorization: Base64.encode("daping:daping"),
      },
      codeImageUrl: "",
      qrcodeStatus: {
        qrcode0: true,
        qrcode1: false,
      },
      showMessage: null, //请拨打客服电话:010-62127261
      showMessageType: 0,
    };
  },
  mounted() {
    this.newCodeImage();

    setTimeout(() => {
      this.model.rmb = !!this.getStorage("rmbUser");
      if (this.model.rmb === true) {
        var username = this.getStorage("Username");
        var password = this.getStorage("Password");
        if (password && username) {
          this.model.username = username;
          this.model.password = Base64.decode(password);
        }
      } else {
        this.model.username = null;
        this.model.password = null;
      }
    }, 1000);

    document.onkeydown = (e) => {
      let event = e || window.event;
      let key = event.keyCode;
      if (key == 13) {
        this.submitClick();
      }
    };
  },
  methods: {
    submitClick() {
      if (
        this.model.username == null ||
        this.model.username.replace(/\s/g, "") == ""
      ) {
        this.showTips("请输入用户名", "warning");
        return;
      }
      if (
        this.model.password == null ||
        this.model.password.replace(/\s/g, "") == ""
      ) {
        this.showTips("请输入密码", "warning");
        return;
      }
      if (this.model.code == null || this.model.code.replace(/\s/g, "") == "") {
        this.showTips("请输入验证码", "warning");
        return;
      }
      let { username, password, code, captchaKey, Authorization } = this.model;
      this.doLogin({
        username,
        password,
        code,
        Authorization,
        key: captchaKey,
      });
    },
    doLogin(data) {
      // window.loading(true);
      this.apiReq
        .doLogin(data)
        .then((result) => {
          // window.loading(false);
          let data = result.data;
          this.$localStorage.set(
            "expires_in",
            data.expires_in,
            data.expires_in* 1000
          );
          this.$localStorage.set(
            "access_token",
            data.access_token,
            data.expires_in* 1000
          );
          this.$localStorage.set(
            "refresh_token",
            data.refresh_token,
            data.expires_in* 1000
          );

          this.setStorage("Username", this.model.username, 7);

          if (this.model.rmb === true) {
            this.setStorage("rmbUser", "true", 7);
            this.setStorage("Password", Base64.encode(this.model.password), 7);
            this.setStorage("userType", data.role, 7);
          } else {
            this.delStorage("userinfo");
            this.delStorage("rmbUser");
            this.delStorage("Password");
            this.setStorage("userType", data.role, 7);
          }
          window.location.href = window.prePath + "/index.html?web#/";
          this.getUserInfo();
        })
        .catch((error) => {
          var msg = error.response.data;
          console.log("error####", msg);
          // window.loading(false);
          this.showTips(msg, "error");
          this.newCodeImage();
          console.log("服务端错误", error);
        });
    },
    getUserInfo() {},
    delStorage(key) {
      this.$localStorage.remove(key);
    },
    getStorage(key) {
      return this.$localStorage.get(key);
    },
    setStorage(key, value, expire) {
      if (key && value) {
        this.$localStorage.set(key, value, 24 * 60 * 60 * 1000);
      }
    },
    newCodeImage() {
      this.model.code = null;
      this.apiReq
        .getCaptcha(this.model.captchaKey)
        .then(res => {
          let base64 = btoa(
            new Uint8Array(res.data).reduce(function(data, byte) {
              return data + String.fromCharCode(byte);
            }, "")
          );
          return base64;
        })
        .then(res => {
          this.codeImageUrl = "data:image/png;base64," + res;
        });
    },
    clickForgetPassword() {
      this.showTips("请拨打客服电话:010-62127261", "info");
    },
    showTips(msg, type) {
      this.$message({ type: type, message: msg });
    },
  },
};
</script>

<style lang="scss">
@import "./main.scss";
.inputbox {
  /deep/.el-checkbox__inner {
    background-color: #1f1f1f;
    border: 1px solid gray;
  }
  /deep/.el-checkbox__input.is-checked .el-checkbox__inner {
    background-color: #1f1f1f;
    border-color: #666666;
  }
  /deep/.el-checkbox__input.is-checked + .el-checkbox__label {
    color: #666666;
  }
}
</style>